import React from "react";
import styles from "./ui.module.scss";
import { useEventStore } from "../../store";
import moment from "moment";

const EventActionStatus = () => {
  const { eventDate, uiStore } = useEventStore();
  const nowDate = moment(new Date()).utc().format();

  if (!eventDate) return null;

  if (nowDate < moment(new Date(eventDate.event_start)).utc().format()) {
    return null;
  }

  if (nowDate > moment(new Date(eventDate.event_end)).utc().format()) {
    return (
      <div className={styles.ActionStatus}>
        <img
          src="/static/images/eventIcons/XCircle.svg"
          alt="Уже закончилось"
        />
        <span>Уже закончилось</span>
      </div>
    );
  }

  return (
    <div className={styles.ActionStatus}>
      <img src="/static/images/eventIcons/watch.svg" alt="Уже идет" />
      <span>Уже идет{uiStore.isMobile ? "" : ". Можно присоединиться"}</span>
    </div>
  );
};

export default EventActionStatus;
